import React, { useState, useEffect } from "react";
import Select from "react-select";
import { getJobDivisions } from "./Axios";

const DivisionsSelect = props => {
  const [divisions, setDivisions] = useState([]);

  const handleChange = inputValue => {
    props.handleChange(inputValue, "division");
  };

  useEffect(() => {
    getJobDivisions((response) => {
      if (response && response.data) {
        const newDivisions = response.data.map((division) => ({
          value: division.id,
          label: division.name,
          uniqueIdentifier: division.unique_identifier,
        }));
        setDivisions(newDivisions);
      }
    });
  }, []);

  return (
    <Select
      inputId="divisions-search"
      onChange={handleChange}
      options={divisions}
      placeholder="Buscar y seleccionar una División"
      value={
        divisions.find(
          (option) => option.value === props.value?.value
        ) || null
      }
      getOptionLabel={(e) => `${e.label} (${e.uniqueIdentifier})`}
      filterOption={(option, input) => {
        const searchTerm = input.toLowerCase();
        const { label, uniqueIdentifier } = option.data;
        return (
          label.toLowerCase().includes(searchTerm) ||
          uniqueIdentifier.toLowerCase().includes(searchTerm)
        );
      }}
      isSearchable={true}
    />
  );
};

export default DivisionsSelect;

